/*
* Broadcast Theme
*
* Dynamic variant option images
*/

(function() {
  const getProductData = (root) => {
    if (!root) return null;

    if (root._variantImageProductData) {
      return root._variantImageProductData;
    }

    const productJson = root.querySelector('[data-product-json]');

    if (!productJson) return null;

    try {
      const product = JSON.parse(productJson.textContent);

      root._variantImageProductData = product;

      return product;
    } catch (error) {
      console.warn('Broadcast variant images:', error);
      return null;
    }
  };


  const getVariantImageUrl = (variant) => {
    if (!variant) return null;

    if (variant.featured_media?.preview_image?.src) {
      return variant.featured_media.preview_image.src;
    }

    if (variant.featured_image?.src) {
      return variant.featured_image.src;
    }

    if (variant.image?.src) {
      return variant.image.src;
    }

    return null;
  };


  const updateVariantOptionImages = (root, currentVariant) => {
    if (!root || !currentVariant) return;

    const product = getProductData(root);

    if (!product?.variants?.length) return;

    const currentOptions =
      currentVariant.options || [
        currentVariant.option1,
        currentVariant.option2,
        currentVariant.option3
      ];


    root
      .querySelectorAll('[data-variant-option-image]')
      .forEach((optionButton) => {

        const input = optionButton.querySelector(
          '[data-single-option-selector]'
        );

        if (!input) return;

        const optionIndex = input.dataset.index;

        if (!optionIndex) return;

        const optionPosition =
          parseInt(optionIndex.replace('option', ''), 10) - 1;

        if (Number.isNaN(optionPosition)) return;


        const matchingVariant = product.variants.find((variant) => {

          const variantOptions =
            variant.options || [
              variant.option1,
              variant.option2,
              variant.option3
            ];


          if (
            variantOptions[optionPosition] !== input.value
          ) {
            return false;
          }


          for (
            let index = 0;
            index < currentOptions.length;
            index++
          ) {

            if (index === optionPosition) continue;

            if (
              currentOptions[index] &&
              variantOptions[index] !== currentOptions[index]
            ) {
              return false;
            }
          }


          return true;
        });


        if (!matchingVariant) return;


        const imageUrl =
          getVariantImageUrl(matchingVariant);

        if (!imageUrl) return;


        const image =
          optionButton.querySelector('.option-image img');

        if (!image) return;


        image.removeAttribute('srcset');
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');

        image.srcset = '';
        image.src = imageUrl;
      });
  };


  document.addEventListener(
    'theme:variant:change',
    (event) => {

      const root = event.target;
      const variant = event.detail?.variant;

      if (!(root instanceof Element)) return;
      if (!variant) return;

      updateVariantOptionImages(root, variant);
    }
  );
})();